import { render } from "./Dialog.vue?vue&type=template&id=27b8635a&ts=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=27b8635a&lang=scss"

import exportComponent from "D:\\work\\h5\\qfx-answer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__